// extracted by mini-css-extract-plugin
export var category = "_le-9";
export var categoryHeader = "_le-e";
export var container = "_le-0";
export var group = "_le-a";
export var groupItems = "_le-f";
export var groupSeparator = "_le-j";
export var loading = "_le-1";
export var noResults = "_le-3";
export var placeholder = "_le-2";
export var resultContent = "_le-5";
export var resultIcon = "_le-c";
export var resultItem = "_le-g";
export var resultMeta = "_le-8";
export var resultSubtitle = "_le-7";
export var resultSuffix = "_le-i";
export var resultTitle = "_le-6";
export var resultsList = "_le-4";
export var searchGroup = "_le-d";
export var selected = "_le-h";
export var subgroup = "_le-b";